const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.leftSection}>
            <h3 style={styles.logo}>Cura</h3>
            <p style={styles.tagline}>
              Your Personal Financial Operating System
            </p>
          </div>

          <div style={styles.rightSection}>
            <p style={styles.copyright}>© 2024 Cura. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

const styles: Record<string, React.CSSProperties> = {
  footer: {
    padding: "2rem 0",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 1rem",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1.5rem",
    flexWrap: "wrap",
  },
  leftSection: {
    textAlign: "left",
  },
  logo: {
    fontSize: "clamp(1.25rem, 3vw, 1.5rem)",
    fontWeight: "600",
    color: "#6366f1",
    marginBottom: "0.25rem",
  },
  tagline: {
    fontSize: "clamp(0.75rem, 2vw, 0.875rem)",
    color: "#6b7280",
  },
  rightSection: {
    textAlign: "right",
  },
  copyright: {
    fontSize: "clamp(0.75rem, 2vw, 0.875rem)",
    color: "#6b7280",
  },
};

export default Footer;
